import { doc, onSnapshot, updateDoc } from 'firebase/firestore'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { db } from '../../../config/firebase'
import {
  FormMedicalRecord,
  FormNonWebEnableForm,
  FormWebEnableForm,
} from '../Components'
import { useToast } from '@chakra-ui/react'

function FillableView() {
  const params = useParams()
  const toast = useToast()
  const [formView, setFormView] = useState(null)

  const convertTimestamp = timestamp => {
    if (!timestamp) return ''
    return timestamp.toDate().toLocaleString('en-US')
  }

  const fetchForm = useCallback(() => {
    try {
      const unsubscribe = onSnapshot(
        doc(db, 'Form', params.id),
        snapshot => {
          if (snapshot.exists) {
            const data = snapshot.data()
            setFormView({
              ...data,
              id: snapshot.id,
              startOneDate: convertTimestamp(data?.startOneDate),
              endOneDate: convertTimestamp(data?.endOneDate),
              startDateRecords: convertTimestamp(data?.startDateRecords),
              endDateRecords: convertTimestamp(data?.endDateRecords),
            })
          }
        },
        err => {
          console.error('Error fetching form:', err)
        }
      )

      // Return cleanup function
      return unsubscribe
    } catch (err) {
      console.error('Error setting up form listener:', err)
      return () => {}
    }
  }, [params.id])

  useEffect(() => {
    const unsubscribe = fetchForm()
    return () => unsubscribe()
  }, [fetchForm])

  const onStatusChange = async (id, status) => {
    if (status === formView?.status) return

    try {
      const formRef = doc(db, 'Form', id)
      await updateDoc(formRef, {
        status: status,
        updatedAt: new Date(),
      }).then(() => fetchForm())
      toast({
        title: 'Status updated',
        description: 'Status updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      console.log(`Status updated to ${status} for document ${id}`)
    } catch (error) {
      toast({
        title: 'Update status error',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
      console.error('Error updating document status:', error)
      // You might want to show an error message to the user here
    }
  }

  return (
    <>
      {formView?.type === 'WebEnableForm' && (
        <FormWebEnableForm
          formView={formView}
          onStatusChange={onStatusChange}
        />
      )}
      {(formView?.type === 'NonWebEnableForm' ||
        formView?.type === 'NewPatientPacket') && (
        <FormNonWebEnableForm
          formView={formView}
          onStatusChange={onStatusChange}
        />
      )}
      {formView?.type === 'MedicalRecord' && (
        <FormMedicalRecord
          formView={formView}
          onStatusChange={onStatusChange}
        />
      )}
    </>
  )
}

export default FillableView
